export { default as ClipboardDocumentCheckOutlineIcon } from './ClipboardDocumentCheckOutlineIcon';
